import { atom } from 'jotai';

export const buildBundleThemeAtom = atom<ThemeSelect>('new');
buildBundleThemeAtom.debugLabel = 'buildBundleThemeAtom';
